module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_191.25deg.d931be00.png";